import React from "react";
import ZeroTrustPolicyDetail from "components/newDesign/zeroTrust/ZeroTrustPolicyDetail";

const ZeroTrustPolicyDetailPage = () => {
  return <ZeroTrustPolicyDetail />;
};

export default ZeroTrustPolicyDetailPage;
